export default function Charter(props) {
    return(
        <div>
            Charter
        </div>
    )
}